/*
 * @Author: JamesWong
 * @Description: 物流配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: James Wong
 * @Last Modified time: 2019-04-19 17:45:39
 */
export default {
  receive: '收貨',
  deliver: '發貨',
  inventory: '盤點',
  createInvoice: '自建單據',
  dispose: '配置',
  modelDisposition: '模組配置',
  modelName: '模組名稱',
  enterModelnameTips: '請填寫模組名稱',
  modelId: '模組ID',
  enterModelIdTips: '請填寫模組ID',
  noticeName: '通知單名稱',
  noticeName1: '盤點單名稱',
  enterNoticenameTips: '請填寫通知單名稱',
  enterNoticenameTips1: '請填寫盤點單名稱',
  noticeId: '通知單ID',
  noticeId1: '盤點單ID',
  enterNoticeIdTips: '請填寫通知單ID',
  enterNoticeIdTips1: '請填寫盤點單ID',
  confirm: '確定',
  cancel: '取消',
  noticeModelName: '通知單模組名稱',
  noticeModelId: '通知單模組ID',
  operate: '操作',
  edit: '編輯',
  delete: '刪除',
  stockCheckPlan: '盤點計畫',
  stockCheckAnalysis: '盤點分析',
  stockChecklist: '盤點單',
  modelAddSuccess: '模組新增成功！',
  modelUpdateSuccess: '模組更新成功！',
  deliveryNotice: '通知單',
  replenishment: '補貨'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-hant/inout.js